import { memo } from 'react';

import { IKnmTypeSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { KNM_APPROVE_INFO } from 'CorePackage/MainModule/routes/routes';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { PROSECUTOR_ORGANIZATION_BLOCK_ID } from 'KnmPackage/MainModule/constants/fieldsElementsIds';
import { IInspectionDecisionSelectOption } from 'KnmPackage/MainModule/interfaces/IInspectionDecisionSelectOption';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { Section } from 'UIPackage/FormModule/components/Section';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';

import { IKnmErpFormReason } from '../interfaces/IKnmErpFormReason';
import { KnmErpApproveInfoDetails } from './KnmErpApproveInfoDetails';
import { KnmErpReasons } from './KnmErpReasons';
import { IAdminSetting } from '../../../APIPackage/AdminModule/interfaces/IAdminSetting';
import { isLaterThanAdminSetting } from '../../../CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { IUserOrganisationSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';
import { AdminSettingCodesEnum } from '../../../APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { KnmErpReasonsErvk } from './KnmErpReasonsErvk';

interface IKnmErpApproveInfoProps {
  approveRequired: boolean | undefined;
  inspectionDecisionId: IInspectionDecisionSelectOption['id'] | undefined;
  planId: IKnm['planId'] | undefined;
  typeCode: IKnmTypeSelectOption['code'] | undefined;
  watchOnly: boolean;
  formKnmReasons: IKnmErpFormReason[] | undefined;
  startDate: string | undefined;
  settings: IAdminSetting[];
  userProsecutorOrganisationsSelectOptions: IUserOrganisationSelectOption[];
  knmData: IKnm | undefined;
}

export const KnmErpApproveInfo = memo(
  ({
    approveRequired,
    inspectionDecisionId,
    planId,
    typeCode,
    watchOnly,
    formKnmReasons,
    startDate,
    userProsecutorOrganisationsSelectOptions,
    settings,
    knmData,
  }: IKnmErpApproveInfoProps) => {
    const isErvkProsecutorOrganizationStartFrom = isLaterThanAdminSetting(
      knmData?.created,
      settings,
      AdminSettingCodesEnum.ERVK_PROSECUTOR_ORGANIZATION_4_1_15_STARTS_FROM,
    );

    const isLaterThanReasonFieldsAvailabilitySetting = isLaterThanAdminSetting(
      knmData?.created,
      settings,
      AdminSettingCodesEnum.ERVK_PARAM_TABLES_4_1_23_STARTS_FROM,
    );

    const isShowProsecutorOrganization =
      knmData?.createdBy?.username === 'SMEV' &&
      !knmData.prosecutorOrganization?.ervkUuid &&
      isErvkProsecutorOrganizationStartFrom;

    return (
      <Section title="Сведения о согласовании" id={KNM_APPROVE_INFO}>
        <Row>
          <FieldBlock id={PROSECUTOR_ORGANIZATION_BLOCK_ID} label="Наименование прокуратуры">
            <SelectInputField
              id="prosecutorOrganization"
              name="prosecutorOrganization"
              options={userProsecutorOrganisationsSelectOptions}
              isClearable
              isSearchable
              disabled={!isShowProsecutorOrganization}
              size="medium"
            />
          </FieldBlock>
        </Row>

        {isLaterThanReasonFieldsAvailabilitySetting ? (
          <KnmErpReasonsErvk watchOnly={watchOnly} />
        ) : (
          <KnmErpReasons
            typeCode={typeCode}
            watchOnly={watchOnly}
            formKnmReasons={formKnmReasons}
            startDate={startDate}
          />
        )}

        <KnmErpApproveInfoDetails
          approveRequired={approveRequired}
          inspectionDecisionId={inspectionDecisionId}
          planId={planId}
          typeCode={typeCode}
          watchOnly={watchOnly}
        />
      </Section>
    );
  },
);
